var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.02 169.098C213.02 193.355 193.355 213.02 169.098 213.02C144.841 213.02 125.177 193.355 125.177 169.098C125.177 144.841 144.841 125.177 169.098 125.177C193.355 125.177 213.02 144.841 213.02 169.098Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8236 54.902C98.8236 79.1593 79.1593 98.8236 54.902 98.8236C30.6448 98.8236 10.9805 79.1593 10.9805 54.902C10.9805 30.6448 30.6448 10.9805 54.902 10.9805C79.1593 10.9805 98.8236 30.6448 98.8236 54.902Z",
    stroke: "#871C6A",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.568 11.5293L12.627 212.47",
    stroke: "#871C6A",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector_6.c46288f8c1a7fab4787a7b0b04e19241.svg";
export { ForwardRef as ReactComponent };